export default __webpack_public_path__ + "askrino.da866897.svg";